import { useTranslation } from "react-i18next";
import { NoElements } from "../../../../components/no-elements";

export const NoUsages = () => {
  const { t } = useTranslation("common");
  return <NoElements item={t("usage", { count: 2 })}></NoElements>;
};
